import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17838 10738"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1,.str2{stroke:#2b2a29;stroke-width:258.524}.str0,.str1{stroke:#1c1b17}.str1{stroke-width:196.995}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541835200">
        <path
          d="M4166 1184h9506c162 0 294-85 294-189V129H3872v866c0 104 132 189 294 189z"
          style={{
            strokeWidth: 258.524,
          }}
          className="fil1-bg stroke1"
        />
        <path
          d="M17156 130h-2111v1525c0 426-348 774-774 774H3568c-427 0-774-348-774-774V130H682c-304 0-553 248-553 553v6167c0 304 249 553 553 553h1526c130-267 324-510 575-714 452-368 1042-570 1664-570h8945c621 0 1211 202 1663 570 251 204 445 447 575 714h1526c304 0 553-249 553-553V683c0-305-249-553-553-553z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 258.524,
          }}
        />
        <path
          d="M12550 6861H5288c-601 0-1124 215-1402 533-127 145-203 312-211 489h10488c-9-177-84-344-210-489-278-318-802-533-1403-533z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 258.524,
          }}
        />
        <path
          d="m3980 9242-1020 1020c-86 86-86 226 0 312 44 44 100 65 157 65 56 0 113-21 156-65l1020-1019c86-86 86-226 0-313-87-86-227-86-313 0zM5492 9242l-1019 1020c-87 86-87 226 0 312 43 44 100 65 156 65s113-21 156-65l1020-1019c86-87 86-226 0-313-86-86-227-86-313 0zM7004 9242l-1019 1020c-87 86-87 226 0 312 43 44 100 65 156 65 57 0 113-21 157-65l1019-1019c86-86 86-226 0-313-86-86-226-86-313 0zM8516 9242l-1019 1020c-86 86-86 226 0 312 43 44 100 65 156 65 57 0 114-21 157-65l1019-1019c86-87 86-226 0-313-86-86-226-86-313 0zM10029 9242l-1020 1020c-86 86-86 226 0 312 43 44 100 65 156 65 57 0 114-21 157-65l1019-1019c87-87 87-226 0-313-86-86-226-86-312 0zM11541 9242l-1020 1020c-86 86-86 226 0 312 43 44 100 65 157 65 56 0 113-21 156-65l1020-1019c86-87 86-226 0-313-87-86-227-86-313 0zM13053 9242l-1020 1020c-86 86-86 226 0 312 44 44 100 65 157 65 56 0 113-21 156-65l1020-1019c86-87 86-226 0-313-87-86-227-86-313 0zM14565 9242l-1019 1020c-87 86-87 226 0 312 43 44 99 65 156 65s113-21 156-65l1020-1019c86-87 86-226 0-313-87-86-227-86-313 0z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 258.524,
          }}
        />
        <circle
          cx={14094}
          cy={3976}
          r={323}
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 258.524,
          }}
        />
        <rect
          width={924}
          height={129}
          x={13632}
          y={5085}
          className="fil1-bg stroke1"
          rx={2850258}
          ry={2850317}
          style={{
            strokeWidth: 258.524,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
